import { useState } from 'react';

const downloads = [
  {
    icon: 'ri-shield-check-line',
    category: 'Protección',
    title: 'Accidente Protegido',
    description: 'Conoce las coberturas y beneficios ante accidentes: atención de urgencia, hospitalización y prestaciones incluidas en tu plan.',
    size: '1.1 MB',
    color: 'from-rose-50 to-rose-100',
    iconColor: 'text-rose-500',
    badgeColor: 'bg-rose-100 text-rose-600',
    file: 'https://drive.google.com/uc?export=download&id=1FXLKRjTVjHwptMNuJh7S0zhkvSt5CyZQ',
  },
  {
    icon: 'ri-heart-line',
    category: 'Familia',
    title: 'Hijo Protegido',
    description: 'Beneficios y coberturas especiales para los hijos como cargas familiares: controles, vacunas, urgencias y más.',
    size: '870 KB',
    color: 'from-pink-50 to-pink-100',
    iconColor: 'text-pink-500',
    badgeColor: 'bg-pink-100 text-pink-600',
    file: 'https://drive.google.com/uc?export=download&id=1dBa5Q45SA5b95TbG2hOwf3VuRJcSfNac',
  },
  {
    icon: 'ri-plane-line',
    category: 'Viajes',
    title: 'Asistencia en Viajes',
    description: 'Cobertura médica durante viajes nacionales e internacionales: emergencias, repatriación y asistencia en el extranjero.',
    size: '950 KB',
    color: 'from-sky-50 to-sky-100',
    iconColor: 'text-sky-600',
    badgeColor: 'bg-sky-100 text-sky-700',
    file: 'https://drive.google.com/uc?export=download&id=1Bak2jwGDslzs6O-oY_2M2bOmw_yOQ-_g',
  },
  {
    icon: 'ri-briefcase-line',
    category: 'Cesantía',
    title: 'Protección en Cesantía',
    description: 'Mantén tu cobertura de salud en caso de quedar sin trabajo. Conoce los plazos, condiciones y cómo activar este beneficio.',
    size: '780 KB',
    color: 'from-amber-50 to-amber-100',
    iconColor: 'text-amber-600',
    badgeColor: 'bg-amber-100 text-amber-700',
    file: 'https://drive.google.com/uc?export=download&id=1K6ODh01v4aqF-T1IEaMkqQEKC8MvKNy4',
  },
  {
    icon: 'ri-home-heart-line',
    category: 'Domicilio',
    title: 'Fonoaudiología y Terapia Ocupacional a Domicilio',
    description: 'Accede a sesiones de fonoaudiología y terapia ocupacional en la comodidad de tu hogar con cobertura de tu isapre.',
    size: '1.0 MB',
    color: 'from-violet-50 to-violet-100',
    iconColor: 'text-violet-600',
    badgeColor: 'bg-violet-100 text-violet-700',
    file: 'https://drive.google.com/uc?export=download&id=1YpmkHC8zQLhAiz3fbRN59imznWQM4mEq',
  },
  {
    icon: 'ri-tooth-line',
    category: 'Dental',
    title: 'Dental RedSalud Full 80',
    description: 'Plan dental con cobertura del 80%: consultas, tratamientos, ortodoncia y prestaciones en la red RedSalud a nivel nacional.',
    size: '690 KB',
    color: 'from-teal-50 to-teal-100',
    iconColor: 'text-teal-600',
    badgeColor: 'bg-teal-100 text-teal-700',
    file: 'https://drive.google.com/uc?export=download&id=1Uga_qh1LbAV036CGwF-mRGxHjLPSAgyX',
  },
  {
    icon: 'ri-tooth-line',
    category: 'Dental',
    title: 'Dental RedSalud Full 70',
    description: 'Plan dental con cobertura del 70%: acceso a consultas, tratamientos y especialidades dentales en la red RedSalud.',
    size: '670 KB',
    color: 'from-emerald-50 to-emerald-100',
    iconColor: 'text-emerald-600',
    badgeColor: 'bg-emerald-100 text-emerald-700',
    file: 'https://drive.google.com/uc?export=download&id=1_Tfn-_8qSn04G3ApKGGB5m-1OavW_uSD',
  },
  {
    icon: 'ri-walk-line',
    category: 'Domicilio',
    title: 'Kinesiología a Domicilio',
    description: 'Sesiones de kinesiología en tu hogar con cobertura incluida. Ideal para rehabilitación post-operatoria y tratamientos continuos.',
    size: '820 KB',
    color: 'from-orange-50 to-orange-100',
    iconColor: 'text-orange-500',
    badgeColor: 'bg-orange-100 text-orange-600',
    file: 'https://drive.google.com/uc?export=download&id=1OjSDXzulGedwBopBSyaTuxBX9rBQJLzh',
  },
];

export default function Downloads() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="descargas" className="py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-6">
            <span className="text-sm font-medium text-teal-700">Material descargable</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Recursos sobre coberturas de tu isapre
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Descarga guías y documentos informativos para entender mejor qué cubre tu plan de salud y cómo aprovecharlo al máximo.
          </p>
        </div>

        {/* Downloads Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {downloads.map((item, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              {/* Card top color strip */}
              <div className={`h-2 w-full bg-gradient-to-r ${item.color}`}></div>

              <div className="p-7">
                {/* Badge + icon */}
                <div className="flex items-start justify-between mb-5">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${item.color}`}>
                    <i className={`${item.icon} text-2xl ${item.iconColor}`}></i>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${item.badgeColor}`}>
                    {item.category}
                  </span>
                </div>

                {/* Text */}
                <h3 className="text-base font-semibold text-gray-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-6">
                  {item.description}
                </p>

                {/* Footer */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center space-x-1 text-xs text-gray-400">
                    <i className="ri-file-line"></i>
                    <span>PDF · {item.size}</span>
                  </div>
                  <a
                    href={item.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-1.5 text-sm font-medium text-teal-700 hover:text-teal-800 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-download-2-line text-base"></i>
                    <span>Descargar</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-14 text-center">
          <div className="inline-flex items-center space-x-2 px-5 py-3 bg-teal-50 rounded-full">
            <i className="ri-information-line text-teal-600"></i>
            <p className="text-sm text-teal-700">
              ¿Necesitas un documento específico? Escríbeme y te lo envío directamente.
            </p>
            <button
              onClick={() => window.open('https://wa.me/56944540956', '_blank')}
              className="ml-2 text-sm font-semibold text-teal-800 underline underline-offset-2 hover:text-teal-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contactar
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
